import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, FloatingLabel, Alert } from "react-bootstrap";
import PageTitle from './components/PageTitle';
import { API_ENDPOINTS } from './config/api';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setError("Invalid reset link. Please request a new password reset.");
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_ENDPOINTS.AUTH}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Password reset successfully! You can now log in with your new password.");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        setError(data.message || "Failed to reset password. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="d-flex align-items-center justify-content-center min-vh-100">
      <PageTitle title="Reset Password" description="Set your new MedHive account password" />
      <Row className="w-100 justify-content-center">
        <Col xs={12} sm={8} md={6} lg={4} xl={3} style={{ width: "400px" }}>
          <Card className="shadow-lg border-0 rounded-4">
            <Card.Body className="p-5 mt-3 mb-3">
              <Card.Title className="text-center mb-4 fs-3">
                Reset Your Password
                <br />
                <small className="text-muted fs-6">Enter your new password</small>
              </Card.Title>

              {error && (
                <Alert variant="danger" className="text-center mb-3">
                  {error}
                </Alert>
              )}

              {message && (
                <Alert variant="success" className="text-center mb-3">
                  {message}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <FloatingLabel controlId="floatingNewPassword" label="New Password" className="mb-3">
                    <Form.Control
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      placeholder="Enter new password"
                      disabled={loading}
                    />
                  </FloatingLabel>
                </Form.Group>

                <Form.Group className="mb-4">
                  <FloatingLabel controlId="floatingConfirmPassword" label="Confirm New Password" className="mb-3">
                    <Form.Control
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      placeholder="Confirm new password"
                      disabled={loading}
                    />
                  </FloatingLabel>
                </Form.Group>

                <Button
                  type="submit"
                  variant="primary"
                  className="w-100 py-2 fw-semibold mb-3"
                  disabled={loading}
                >
                  {loading ? "Resetting..." : "Reset Password"}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPassword; 